import Sidebar from './sidebar';
import { Helmet } from 'react-helmet-async';
import React,{ useState,useEffect } from 'react';
import { ToggleRight } from "react-feather";
import api from "../api";
import { PaystackButton } from 'react-paystack';
import PricingCon from '../pricing-con';
import { FaClock } from 'react-icons/fa';
import { Link } from 'react-router-dom';
function SellerSubscription(){
    const baseUrl = process.env.REACT_APP_BASE_URL;
    const publicKey = process.env.REACT_APP_PAYSTACK_PUBLIC_KEY; 
    const [UsernameError,setUsernameError]=useState(false);
        const [growthoffr, setgrowthoffr] = useState("");
    const [PackageAmount,setPackageAmount]=useState(false);
    const [TotalPackageAmount,setTotalPackageAmount]=useState(false);
    const [PackageAnnualAmount,setPackageAnnualAmount]=useState(false);
    const [PackageName,setPackageName]=useState(false);
    const [selectedPaymentMode, setSelectedPaymentMode] = useState('0');
    const [selectedPaymentModeName, setSelectedPaymentModeName] = useState('Monthly');
    const [oneYearFromToday, setOneYearFromToday] = useState('');
    const [oneMonthFromToday, setOneMonthFromToday] = useState('');
    const [ExpDate, setExpDate] = useState('');
    const [packageDetails, setPackageDetails] = useState(null);
    
    const [EmailError,setEmailError]=useState(false);
    const [UsernameError0,setUsernameError0]=useState('0');
    const [EmailError0,setEmailError0]=useState('');
    const [PayError, SetPayError]=useState('');

    const token = localStorage.getItem("access_token");  

    const [transactions, setTransactions] = useState([]);

    const [currency, setcurrency] = useState("");
    const [plan1, setplan1] = useState(0);
    const [plan2, setplan2] = useState(0);
    const [plan3, setplan3] = useState(0);
    const [plan4, setplan4] = useState(0);
    const [plan10, setplan10] = useState(0);
    const [plan20, setplan20] = useState(0);
    const [plan30, setplan30] = useState(0);
    const [plan40, setplan40] = useState(0);
    const [ProfileData,setProfileData]=useState({  
        "user_id":'', 
        "first_name":'',
        "last_name":'',
        "username":'',
        "customer_email":'',
        "mobile":0,
        "address":'',
        "p_image":'',
    });

    const inputHandler =(event) => {
        setProfileData({
            ...ProfileData,
            [event.target.name]:event.target.value
        });
    };

    async function getLocationAndSetPricing() {
        let countryCode = localStorage.getItem("kadhr_country_code");

        if (!countryCode) {
            try {
                const response = await fetch("https://ipapi.co/json/");
                const data = await response.json();
                countryCode = data.country_code;

                // Save to localStorage
                localStorage.setItem("kadhr_country_code", countryCode);
            } catch (error) {
                // Handle error or use default
                // console.error("Error fetching location:", error);
                countryCode = "US"; // fallback
            }
        }

        let prices, prices0, currency;

        if (countryCode === "KE" || countryCode === "KES") {
            prices = [0, 999, 4999, 14999];
            prices0 = [0, 9990, 49990, 149990];
            currency = "KES";
            setgrowthoffr("Custom domain");
        } else {
            prices = [0, 20, 50, 150];
            prices0 = [0, 200, 500, 1500];
            currency = "USD";
            setgrowthoffr("Custom domain");
        }

        setplan1(prices[0]);
        setplan2(prices[1]);
        setplan3(prices[2]);  
        setplan4(prices[3]); 
        
        setplan10(prices0[0]);
        setplan20(prices0[1]);
        setplan30(prices0[2]);
        setplan40(prices0[3]);  
        setcurrency(currency);
    }   

    useEffect(()=>{
        // Call function on page load
        const fetchTransactions = async () => {
            try {
                const token = localStorage.getItem("access_token"); // Get authentication token
                const response = await api.get(baseUrl+"/vendor-transactions/", {
                    headers: { Authorization: `Bearer ${token}` },
                });
                setTransactions(response.data);
            } catch (error) {
                //console.error("Error fetching transactions:", error);
            }
        };
        const fetchPackageDetails = async () => {
            try {
              const token = localStorage.getItem("access_token"); // Get authentication token
              const response = await api.get(baseUrl+"/vendor-package/", {
                headers: { Authorization: `Bearer ${token}` },
              });
              setPackageDetails(response.data);
            } catch (error) {
              //console.error("Error fetching package details:", error);
            }
        };
      
        fetchPackageDetails();
    
        fetchTransactions();
        getLocationAndSetPricing();
        fetchData();
        const formatDate = (date) => {
            return date.toLocaleDateString('en-GB', {
                day: '2-digit',
                month: 'long',
                year: 'numeric',
            });
        };

        const today = new Date();
        const oneYearLater = new Date();
        oneYearLater.setFullYear(today.getFullYear() + 1);

        const oneMonthLater = new Date();
        oneMonthLater.setMonth(today.getMonth() + 1);

        setOneYearFromToday(formatDate(oneYearLater));
        setOneMonthFromToday(formatDate(oneMonthLater));
        setExpDate(formatDate(oneMonthLater));
    },[]);
    
    const validateEmail = (email) => {
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (email && !emailPattern.test(email)) {
            setEmailError(true);setEmailError0('0');
        } else {
            setEmailError(false);setEmailError0('1');
        }
    };
    const validateUsername = (username) => {
        if(username.length<3){
            setUsernameError(true);setUsernameError0('0'); return;
        }else{
            setUsernameError(false);setUsernameError0('1');
        } 
    };

    useEffect(() => {
        if (ProfileData.username) {
            validateUsername(ProfileData.username);
        }
        if (ProfileData.email) {
            validateEmail(ProfileData.email);
        }
    }, [ProfileData.username, ProfileData.email]);


    const fetchData = async () => {
        try {
            const response = await api.get(baseUrl+'/vendor/', {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            const data = response.data;
            setProfileData({
                user_id: data.user?.id || '',
                first_name: data.user?.first_name || '',
                last_name: data.user?.last_name || '',
                username: data.user?.username || '',
                email: data.user?.email || '',
                mobile: data.mobile || '',
                address: data.address || '',
                p_image: data.profile_img || '',
                ig: data.ig || '',
                tk: data.tk || '',
                tw: data.tw || '',
                yt: data.yt || '',
                fb: data.fb || '',
            });
        } catch (error) {
            //setError('Failed to fetch customer data. Please try again later.');
        } finally {
            //setLoading(false);
        }
    };

    function StepOne(amount,name,annual){
        setPackageAmount(amount);
        setPackageName(name);
        setPackageAnnualAmount(annual);
        setSelectedPaymentMode('0');
        setTotalPackageAmount(amount);
        setSelectedPaymentModeName("Monthly");
        setExpDate(oneMonthFromToday);
    }
    const handleRadioChange = async (event) => {
        const newPaymentMode = event.target.value;
        setSelectedPaymentMode(newPaymentMode);
        if(newPaymentMode === 0){
            setSelectedPaymentModeName("Monthly");
            setExpDate(oneMonthFromToday);
            setTotalPackageAmount(PackageAmount);
        }else{
            setSelectedPaymentModeName("Annualy");
            setExpDate(oneYearFromToday);
            setTotalPackageAmount(PackageAnnualAmount);
        }
    };

    if (!packageDetails) {
        return <p>Loading package details...</p>;
    }
    
    const handlePaymentSuccess = async (response) => {
        var smsRefill = 0;
        if(PackageName == 'Premium'){
            smsRefill = 100;
        }else if(PackageName == 'Growth'){
            smsRefill = 300;
        }else if(PackageName == 'Advanced'){
            smsRefill = 1000;
        }

        const payload = {
            email: ProfileData.email,
            total_amount:TotalPackageAmount,
            trxref: response.trxref,
            trans: response.trans,
            package: PackageName,
            tdateto: ExpDate,
            sms_refill: smsRefill,
        };
    
        try {
            const res = await api.post(baseUrl+`/subscription-checkout/`, payload, {
                headers: {
                  Authorization: `Bearer ${localStorage.getItem("access_token")}`,
                },
              }); 
            if(res.data.success){
                window.location.href = '/seller/subscription';
            } 
        } catch (error) {
            //console.error('Failed to update order status:', error.response?.data || error.message);
            //alert('Failed to update order status.');
        }
    };

    const handlePaymentClose = async () => {    
        SetPayError('Transaction was not completed.');
    };
    
    const onSuccess = (response) => {
        handlePaymentSuccess(response);
    };

    const onClose = () => {
        //alert('Transaction was not completed, window closed.');
        //console.error('Transaction was not completed, window closed.');
        handlePaymentClose();
    };

    function formatDate0(dateInput) {
        if (!dateInput) return "";

        // already in "Dec 2026" format
        if (
            typeof dateInput === "string" &&
            /^[A-Za-z]{3}\s\d{4}$/.test(dateInput)
        ) {
            return dateInput;
        }

        let date;

        if (dateInput instanceof Date) {
            date = dateInput;
        } else {
            date = new Date(dateInput);
        }

        if (isNaN(date.getTime())) {
            return dateInput; // graceful fallback
        }

        const month = date.toLocaleDateString("en-US", {
            month: "short",
        });

        const day = date.getDate();
        const year = date.getFullYear();

        return `${month} ${day}, ${year}`;
    }
    
    return (
        <>                                                      
            <Helmet>
                <title>Subscription</title>
                <meta name="description" content={`Subscription`} />
            </Helmet>
            <section className="container mtopcon dashb">            
                <div className="row">
                    
                        <div className="col-12 col-lg-2 dash-min mb-3">
                            <div className="nav-left-sidebar sidebar-dark pc">
                                <div className="slimScrollDiv" ><div className="menu-list" >
                                    <nav className="navbar navbar-expand-lg navbar-light nav-l-con">
                                        <a className="d-xl-none d-lg-none" href="#"></a>
                                        <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                                            <span className="navbar-toggler-icon"></span>
                                        </button>
                                        <div className="collapse navbar-collapse" id="navbarNav">
                                            <Sidebar/>
                                        </div>
                                    </nav>
                                </div><div className="slimScrollBar"></div><div className="slimScrollRail"></div></div>
                            </div>
                        </div>
                        <div className="col-12 col-lg-10 dash-max orderscontainer">
                            <div className="row mb-3 ph-header-con">
                                <div className="col-12 pt-2"><h6 className="pageheader-title mb-3">Subscription Overview </h6></div>
                            </div>

                            <div className="mb-4">

                                <div className="row">
                                    <div className="col-xl-3 col-lg-3 col-md-3 col-sm-12 col-12 mb-3">
                                        <div className="col-xl-12 col-lg-12 col-md-6 col-sm-12 col-12">
                                            <div className="section-block">
                                                <h6 className="mb-3">Current Package </h6>
                                            </div>
                                        </div>  
                                        <div className="card mb-3">
                                            {packageDetails.package_name == "0" && <>
                                                <div className="row p-3 m-0">
                                                    <div className="row ordbgrw pb-2">
                                                        <div className="col-6 ord-sz1 pt-2">
                                                            <div className="row p-0 m-0">
                                                            <div className="col-12 grey-text font9">Package Name</div>
                                                            <div className="col-12 font-bold">Starter</div>
                                                            </div>
                                                        </div>
                                                        <div className="col-6 ord-sz1 pt-2">
                                                            <div className="row p-0 m-0">
                                                                <div className="col-12 grey-text font9">Status</div>
                                                                <div className="col-12 font-bold">
                                                                    <span className="text-success">Active</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-12 ord-sz1 pt-3">
                                                            <div className="row p-0 m-0">
                                                                <p>Premium gives you the tools to sell smarter, connect better, and grow faster - with unlimited products, analytics, and more.<br/><br/>
                                                                🚀 Upgrade today and get <b>2 months free</b> on yearly plans.</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </>}
                                            {packageDetails.package_name != "0" && <>                                        
                                            <div className="row p-3 m-0">
                                                <div className="row ordbgrw pb-2">
                                                    <div className="col-6 ord-sz1 pt-2">
                                                        <div className="row p-0 m-0">
                                                        <div className="col-12 grey-text font9">Package Name</div>
                                                        <div className="col-12 font-bold">
                                                            {packageDetails.package_name?.toLowerCase() === "premium" ? "PAYG" : packageDetails.package_name}
                                                        </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-6 ord-sz1 pt-2">
                                                        <div className="row p-0 m-0">
                                                        <div className="col-12 grey-text font9">Status</div>
                                                        <div className="col-12 font-bold">
                                                            <span className={packageDetails.status === "Active" ? "text-success" : "text-danger"}>
                                                            {packageDetails.status}
                                                            </span>
                                                        </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-6 ord-sz1 pt-2">
                                                        <div className="row p-0 m-0">
                                                        <div className="col-12 grey-text font9">Publish Date</div>
                                                        <div className="col-12 font-bold">{formatDate0(packageDetails.publish_date)}</div>
                                                        </div>
                                                    </div>
                                                    <div className="col-6 ord-sz1 pt-2">
                                                        <div className="row p-0 m-0">
                                                        <div className="col-12 grey-text font9">Ends</div>
                                                        <div className="col-12 font-bold">{formatDate0(packageDetails.end_date)}</div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            </>}
                                        </div>
                                    </div>
                                    
                                    <div className="col-xl-9 col-lg-9 col-md-9 col-sm-12 col-12">
                                        <div className="col-xl-12 col-lg-12 col-md-6 col-sm-12 col-12">
                                            <div className="section-block">
                                                <h6 className="mb-3">Select New Package</h6>
                                            </div>
                                        </div>
                                            <div className="row">
                                                <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-12">
                                                    <div className="card">
                                                        <span className="yrprc br-0 price2yr-bg text-white text-center">No monthly commitment</span>
                                                        <div className="card-header h-auto bg-white text-center p-4 ">
                                                            <h4 className="mb-1 font-bold">PAY AS YOU GO</h4>
                                                            <h1 className="mb-1"><span className="font-24">{currency}</span><sub className="display-4 fbold">0</sub></h1>
                                                            <p>to start</p>
                                                            <p className="text-center font8 lh0 pt-3">
                                                                Recharge → bring customers back → make money
                                                            </p>
                                                        </div>
                                                        <div className="card-body">
                                                            <ul className="pl-0 font9">
                                                                {/* CORE SETUP */}
                                                                <li><p>1 User</p></li>
                                                                <li><p>Storefront</p></li>
                                                                <li><p>Sales & Customer Capture (POS Lite)</p></li>
                                                                <li><p>Order & Stock Management</p></li>
                                                                <li><p>Up to 100 Products</p></li>
                                                                <li><p>Up to 1,000 monthly orders</p></li>

                                                                {/* GROWTH & RETENTION */}
                                                                <li><p><b>Repeat Revenue Agent</b></p></li>
                                                                <li><p>Customer Segmentation</p></li>
                                                                <li><p>Omni-channel (SMS)</p></li> 
                                                                <li><p>Advanced Insights</p></li>

                                                                {/* INTEGRATIONS */}
                                                                <li><p>POS, WooCommerce & API Integrations</p></li>

                                                                {/* PAYMENTS */}
                                                                <li><p>Mobile Money Payments (2%)</p></li>
                                                                <li><p>Cards (3–4%)</p></li>

                                                                {/* SUPPORT */}
                                                                <li><p>Email Support</p></li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-12">
                                                    <div className="card hgtsubprc">
                                                        <span className="yrprc br-0 price2yr-bg text-white text-center">{currency}. {parseFloat(plan30).toLocaleString()}/year 2 Months Free</span>
                                                        <div className="card-header h-auto bg-white text-center p-4 ">
                                                            <h4 className="mb-1 font-bold">GROWTH</h4>
                                                            <h1 className=" mb-1"><span className="font-24">{currency}</span><sub className="display-4 fbold">{parseFloat(plan3).toLocaleString()}</sub></h1>
                                                            <p>per month</p>
                                                            {plan4 > 0 && <>
                                                                <a href="#" data-bs-toggle="modal" data-bs-target="#selectPackage" className="btn btn-primary mb-2 gtst sdhstl w-100 pb-3 pt-3 br50r" onClick={()=>StepOne(plan3,'Growth',plan30)}>
                                                                    Scale with Growth
                                                                </a>
                                                            </>}
                                                        </div>
                                                        <div className="card-body">
                                                            <ul className="pl-0 font9">
                                                                <li><p><b>Everything in Pay As You Go</b></p></li>
                                                                <li><p>Up to 4 staff accounts</p></li>
                                                                <li><p>Unlimited Products</p></li>
                                                                <li><p>Unlimited monthly orders</p></li>
                                                                <li><p><b>Advanced Repeat Revenue Agent</b></p></li>                                    
                                                                <li><p>Advanced segmentation (RFM, behavior)</p></li>          
                                                                <li><p>Advanced analytics (LTV, churn, cohorts)</p></li>  
                                                                <li><p>Multi-channel (WhatsApp, SMS)</p></li> 
                                                                <li><p>Advanced relationship insights</p></li>
                                                                <li><p>Mæven Assistant</p></li>
                                                                <li><p>400 SMS Credits</p></li>
                                                                <li><p>Priority Support</p></li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-12">
                                                    <div className="card hgtsubprc bg-dark text-white">
                                                        <span className="yrprc br-0 price2yr-bg text-dark text-center bg-dark">-</span>
                                                        <div className="card-header h-auto bg-dark text-left border-0 p-4 ">
                                                            <h4 className="mb-1 font-bold text-white">ENTERPRISE</h4>
                                                            <h1 className=" mb-3 text-white">Let's talk</h1>
                                                            <Link className="main-btn btn-hover border-btn mb-4 ctabtn text-white border-white" to="mailto:hello@kadhr.com">
                                                                Contact Sales
                                                            </Link>
                                                        </div>
                                                        <div className="card-body">
                                                            <ul className="pl-0 font9">
                                                                <li><p><b>Everything in Growth</b></p></li>   
                                                                <li><p>API access & Webhooks</p></li> 
                                                                <li><p>Embedded widgets</p></li> 
                                                                <li><p>Data warehouse sync</p></li>                    
                                                                <li><p>Custom workflows</p></li>    
                                                                <li><p>Unlimited staff accounts</p></li>
                                                                <li><p>Account manager</p></li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                    </div>
                                </div>
                                <hr className="hddsktp0"></hr>
                                <h6 className="pageheader-title mb-3">Subscription History </h6>
                                <div>
                                        {transactions.length > 0 ? (
                                            transactions.map((transaction, index) => (
                                            <div key={transaction.id} className="row ord-bg bg-white p-2 pointer hvr bx-shadow">
                                                <div className="w-auto me-3 rownumsn p-0">
                                                <div className="pt-2 pl-2 font8">{index + 1}</div>
                                                </div>
                                                <div className="col-10 pl-0 pr-0">
                                                <div className="row">
                                                    <div className="col-7 col-lg-3 ord-sz">{transaction.user_identification}</div>
                                                    <div className="col-5 col-lg-3 ord-sz text-primary">{transaction.status}
                                                        {transaction.status === false && (
                                                            <span className="badge rounded-pill text-bg-warning">Processing</span>
                                                        )}
                                                        {transaction.status === true && (
                                                            <span className="badge rounded-pill text-bg-success">Complete</span>
                                                        )}
                                                    </div>
                                                    <div className="col-7 col-lg-3 ord-sz grey-text">
                                                    {transaction.package} - Ksh. {Intl.NumberFormat().format(transaction.total_amount)}
                                                    </div>
                                                    <div className="col-5 col-lg-3 ord-sz grey-text">{formatDate0(transaction.created_at)}</div>
                                                </div>
                                                </div>
                                            </div>
                                            ))
                                        ) : (
                                            <p>No transactions found.</p>
                                        )}
                                </div>
                                
                            </div>


                    </div>
                </div>

                <div className="modal fade" id="selectPackage" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                    <div className="modal-dialog mt70">
                        <div className="modal-content">
                            <div className="modal-body pb-2">                                  
                                <h6><ToggleRight width={'18px'} className="rwdlogo" /> {PackageName}</h6>
                                <div className="mb-4">
                                    <div className="grey-text font9 mb-3">Select your preferred payment plan.</div>
                                    <hr/>                               
                                        
                                    <div className="row">
                                                <div className="col-6">
                                                    <div className="card border-top-secondary btp2 mb-0">
                                                        <div className="card-body">
                                                            <div className="font9"><b>Monthly</b></div>
                                                                <p className="font9">{currency} {parseFloat(PackageAmount).toLocaleString()}</p>
                                                            <div className="metric-value d-inline-block">
                                                                <input
                                                                    type="radio"
                                                                    value="0"
                                                                    checked={selectedPaymentMode === '0'}
                                                                    onChange={handleRadioChange}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div> 
                                                </div>
                                                <div className="col-6">
                                                    <div className="card border-top-secondary btp3 mb-0">
                                                        <div className="card-body">
                                                            <div className="font9"><b>Annualy</b></div>
                                                                <p className="font9">{currency} {parseFloat(PackageAnnualAmount).toLocaleString()}</p>
                                                            <div className="metric-value d-inline-block">
                                                                <input
                                                                    type="radio"
                                                                    value="1"
                                                                    checked={selectedPaymentMode === '1'}
                                                                    onChange={handleRadioChange}
                                                                />
                                                            </div>
                                                            <div className="metric-label d-inline-block float-right text-success font-weight-bold">
                                                                <span className="ml-1 font8"><b>2 Months Free</b></span><br/>
                                                            </div>
                                                        </div>
                                                    </div> 
                                                </div>
                                    </div>                                
                                    <button type="button"className="col-12 btn btn-primary mt-4" data-bs-toggle="modal" data-bs-target="#selectPackagePay">Proceed</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="modal fade" id="selectPackagePay" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                    <div className="modal-dialog mt70 mw400">
                        <div className="modal-content">
                            <div className="modal-body pb-2">                                  
                                <h6><ToggleRight width={'18px'} className="rwdlogo" /> {PackageName}</h6>
                                <div className="mb-4">
                                    <div className="row ordbgrw">
                                        <div className="col-4 ord-sz1 pt-2"><font className="grey-text">Total</font><br/> 
                                            <span>KES {new Intl.NumberFormat().format(TotalPackageAmount)}</span>
                                        </div>
                                        <div className="col-8 ord-sz1 pt-2"><font className="grey-text">Payment Mode:</font><br/> {selectedPaymentModeName}</div>
                                        <div className="col-8 ord-sz1 pt-2"><font className="grey-text">Valid Till:</font><br/> {ExpDate}</div>
                                    </div> 
                                    <hr/>     
                                    <div className="tab-content pymt pb-2" id="myTabContent">
                                        <div className="tab-pane fade show active" id="home-tab-pane" role="tabpanel" aria-labelledby="home-tab" tabIndex="0">
                                        <>
                                                <div className="mb-3 mt-3">
                                                        <label htmlFor="lnm" className="grey-text font9 mb-0 pb-0">Username</label>
                                                        <input type="text" className="form-control" id="lnm" name='username' onBlur={(e) => validateUsername(e.target.value)} onChange={inputHandler} value={ProfileData.username || ''} />                                                        
                                                        {UsernameError && <small className="text-danger font8">Confirm username</small>}
                                                </div>
                                                <div className="mb-3 mt-3">
                                                        <label htmlFor="lnm" className="grey-text font9 mb-0 pb-0">Email</label>
                                                        <input type="email" className="form-control" id="lnm" name='email' onBlur={(e) => validateEmail(e.target.value)}  onChange={inputHandler} value={ProfileData.email || ''} />                                                        
                                                        {EmailError && <small className="text-danger font8">Invalid email format. Kindly enter a valid email.</small>}
                                                </div>
                                                {UsernameError0 === '1' && EmailError0 === '1' && ProfileData.email && TotalPackageAmount > 0 ? (
                                                    <PaystackButton 
                                                        className='btn col-12 text-light bg-dark mt-3'
                                                        text="Complete"
                                                        currency="KES"
                                                        publicKey={publicKey}
                                                        email={ProfileData.email}
                                                        amount={TotalPackageAmount * 100}
                                                        onSuccess={onSuccess}
                                                        onClose={onClose}
                                                    />
                                                ) : (
                                                    <button className='btn col-12 text-light bg-dark mt-3' disabled>Complete</button>
                                                )}

                                            </>  
                                        </div>
                                    </div>


                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </section>
        </>
    )
}

export default SellerSubscription;